module.exports = __webpack_public_path__ + "img/GoogleMyBusiness.fcc34b98.svg";